import { render, staticRenderFns } from "./ListaApertura.vue?vue&type=template&id=48047b98&"
import script from "./ListaApertura.vue?vue&type=script&lang=js&"
export * from "./ListaApertura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports